import { render, staticRenderFns } from "./ManageOriginCardSet.vue?vue&type=template&id=7172d774&scoped=true&"
import script from "./ManageOriginCardSet.vue?vue&type=script&lang=js&"
export * from "./ManageOriginCardSet.vue?vue&type=script&lang=js&"
import style0 from "./ManageOriginCardSet.vue?vue&type=style&index=0&id=7172d774&prod&lang=scss&scoped=true&"
import style1 from "./ManageOriginCardSet.vue?vue&type=style&index=1&id=7172d774&prod&lang=sass&scoped=true&"
import style2 from "./ManageOriginCardSet.vue?vue&type=style&index=2&id=7172d774&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7172d774",
  null
  
)

export default component.exports